import React, { useState, useEffect } from 'react';
import { getBallsThrown } from '../utils/statistika';

const KLUBOVI = ['KK Rad', 'KK Rad 2', 'ŽKK Olimp'];
const SEZONE = ['2025/2026', '2026/2027'];

function Ranglista({ igraci, utakmice, inicialniKlub, setAktivna, globalnaSezona }) {
  const [aktivniKlub, setAktivniKlub] = useState(inicialniKlub || KLUBOVI[0]);
  const [filterSezona, setFilterSezona] = useState(globalnaSezona || '2025/2026');

  // Sync filterSezona kad se globalnaSezona promijeni (auto-detekcija pri loadu)
  useEffect(() => { setFilterSezona(globalnaSezona); }, [globalnaSezona]);

  // Kad se promijeni klub, ažuriraj history state da se sačuva pri povratku
  useEffect(() => {
    const curr = window.history.state;
    if (curr?.strana === 'ranglista') {
      window.history.replaceState({ ...curr, klub: aktivniKlub }, '');
    }
  }, [aktivniKlub]);
  const [sortPolje, setSortPolje] = useState('prosjekPoSetu');

  const utakmiceKluba = utakmice.filter(u => u.klub === aktivniKlub && u.sezona === filterSezona);
  const utakmiceDomaci = utakmiceKluba.filter(u => u.domaci === true);
  const utakmiceGost = utakmiceKluba.filter(u => u.domaci === false);

  const getProsjek = (lista) => lista.length === 0 ? 0
    : Math.round(lista.reduce((a, u) => a + (u.ekipaUkupno || 0), 0) / lista.length);

  const pobjede = utakmiceKluba.filter(u => u.ekipaBodovi === 2).length;
  const remiji = utakmiceKluba.filter(u => u.ekipaBodovi === 1).length;
  const porazi = utakmiceKluba.filter(u => u.ekipaBodovi === 0).length;
  const bodovi = utakmiceKluba.reduce((a, u) => a + (u.ekipaBodovi || 0), 0);
  const prosjek = getProsjek(utakmiceKluba);
  const prosjekDomaci = getProsjek(utakmiceDomaci);
  const prosjekGost = getProsjek(utakmiceGost);

  // Prikupi sve igrače koji su nastupali za klub u ovoj sezoni (uključujući transferisane)
  const igracIdsSet = new Set();
  utakmiceKluba.forEach(u => {
    (u.rezultati || []).forEach(r => { if (r.igracId) igracIdsSet.add(r.igracId); });
  });

  const stats = [...igracIdsSet].map(igracId => {
    const igrac = igraci.find(i => i.id === igracId);
    // Ako igrač nije u bazi, uzmi podatke iz utakmice
    const prvaUtakmica = utakmiceKluba.find(u => u.rezultati?.some(r => r.igracId === igracId));
    const prviRez = prvaUtakmica?.rezultati?.find(r => r.igracId === igracId);
    const ime = igrac?.ime || prviRez?.ime || 'Nepoznat';
    const slika = igrac?.slika || null;

    const igracUtakmice = utakmiceKluba.filter(u => u.rezultati?.some(r => r.igracId === igracId));
    let ukupnoCunjeva = 0, ukupnoKugli = 0, domaciCunjeva = 0, domaciKugli = 0;
    let gostCunjeva = 0, gostKugli = 0, ukupnoSP = 0, ukupnoMP = 0;
    let maxUkupno = 0, ukupnoPromasaja = 0;

    igracUtakmice.forEach(u => {
      const r = u.rezultati.find(r => r.igracId === igracId);
      if (!r) return;
      const kugle = getBallsThrown(r);
      const cunjevi = r.ukupno || 0;
      ukupnoCunjeva += cunjevi;
      ukupnoKugli += kugle;
      ukupnoSP += r.sp || 0;
      ukupnoMP += r.mp || 0;
      ukupnoPromasaja += r.promasaji || 0;
      if (cunjevi > maxUkupno) maxUkupno = cunjevi;
      if (u.domaci) { domaciCunjeva += cunjevi; domaciKugli += kugle; }
      else { gostCunjeva += cunjevi; gostKugli += kugle; }
    });

    const prosjekUtakmica = ukupnoKugli > 0 ? Math.round((ukupnoCunjeva / ukupnoKugli) * 120) : 0;
    const prosjekPoSetu = Math.round(prosjekUtakmica / 4);
    const prosjekDom = domaciKugli > 0 ? Math.round((domaciCunjeva / domaciKugli) * 120) : 0;
    const prosjekGos = gostKugli > 0 ? Math.round((gostCunjeva / gostKugli) * 120) : 0;
    // Prosjek promašaja normalizovan na 120 bacanja
    const prosjekPromasaja = ukupnoKugli > 0 ? Math.round((ukupnoPromasaja / ukupnoKugli) * 120 * 10) / 10 : 0;

    return {
      id: igracId, ime, slika,
      nastupa: igracUtakmice.length, ukupnoCunjeva, ukupnoSP, ukupnoMP,
      maxUkupno, prosjekPromasaja, prosjekPoSetu, prosjekUtakmica,
      prosjekDomaci: prosjekDom, prosjekGost: prosjekGos,
    };
  })
    .filter(s => s.nastupa > 0)
    .sort((a, b) => b[sortPolje] - a[sortPolje]);

  const sortOpcije = [
    { id: 'prosjekPoSetu', naziv: 'Prosjek/set' },
    { id: 'prosjekUtakmica', naziv: 'Prosjek/utakmica' },
    { id: 'prosjekDomaci', naziv: 'Domaći' },
    { id: 'prosjekGost', naziv: 'Gost' },
    { id: 'maxUkupno', naziv: 'Max' },
    { id: 'ukupnoSP', naziv: 'SP' },
    { id: 'ukupnoMP', naziv: 'MP' },
    { id: 'nastupa', naziv: 'Nastupa' },
  ];

  return (
    <div>
      <div className="page-title">Rang lista</div>

      <div className="filter-bar">
        {SEZONE.map(s => (
          <button key={s} className={'filter-btn ' + (filterSezona === s ? 'active' : '')}
            onClick={() => setFilterSezona(s)}>{s}</button>
        ))}
      </div>
      <div className="filter-bar">
        {KLUBOVI.map(k => (
          <button key={k} className={'filter-btn ' + (aktivniKlub === k ? 'active' : '')}
            onClick={() => setAktivniKlub(k)}>{k}</button>
        ))}
      </div>

      {/* Ekipni pregled */}
      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: '20px' }}>
        {[
          { naziv: 'Utakmica', vrijednost: utakmiceKluba.length },
          { naziv: 'Pobjede', vrijednost: pobjede, boja: '#2ed573' },
          { naziv: 'Remiji', vrijednost: remiji, boja: '#5378ff' },
          { naziv: 'Porazi', vrijednost: porazi, boja: '#e94560' },
          { naziv: 'Bodova', vrijednost: bodovi },
          { naziv: 'Prosjek', vrijednost: prosjek },
          { naziv: 'Domaći', vrijednost: prosjekDomaci, boja: '#2ed573' },
          { naziv: 'Gost', vrijednost: prosjekGost, boja: '#5378ff' },
        ].map(s => (
          <div key={s.naziv} className="stat-card">
            <div className="broj" style={s.boja ? { color: s.boja } : {}}>{s.vrijednost}</div>
            <div className="naziv">{s.naziv}</div>
          </div>
        ))}
      </div>

      {/* Sort */}
      <div style={{ display: 'flex', gap: '8px', marginBottom: '14px', flexWrap: 'wrap', alignItems: 'center' }}>
        <span style={{ fontSize: '13px', color: '#666688' }}>Sortiraj po:</span>
        {sortOpcije.map(o => (
          <button key={o.id} className={'filter-btn ' + (sortPolje === o.id ? 'active' : '')}
            onClick={() => setSortPolje(o.id)}>{o.naziv}</button>
        ))}
      </div>

      {/* Tabela */}
      {stats.length === 0 ? (
        <div className="card empty-state">
          <div className="icon">🎳</div>
          <p>Nema igrača za odabranu sezonu.</p>
        </div>
      ) : (
        <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ minWidth: '860px' }}>
              <thead>
                <tr>
                  <th style={{ width: '44px', textAlign: 'center' }}>#</th>
                  <th>Igrač</th>
                  <th style={{ textAlign: 'center' }}>Nast.</th>
                  <th style={{ textAlign: 'center', color: '#e94560' }}>Prosj./set</th>
                  <th style={{ textAlign: 'center' }}>Prosj./utakm.</th>
                  <th style={{ textAlign: 'center', color: '#2ed573' }}>Domaći</th>
                  <th style={{ textAlign: 'center', color: '#5378ff' }}>Gost</th>
                  <th style={{ textAlign: 'center' }}>Max</th>
                  <th style={{ textAlign: 'center' }}>SP</th>
                  <th style={{ textAlign: 'center' }}>MP</th>
                  <th style={{ textAlign: 'center' }}>Ø Pr.</th>
                </tr>
              </thead>
              <tbody>
                {stats.map((s, i) => (
                  <tr key={s.id} onClick={() => setAktivna({ strana: 'profil', igracId: s.id, povratakNa: { strana: 'ranglista', klub: aktivniKlub } })}
                    style={{ cursor: 'pointer' }}>
                    <td style={{ textAlign: 'center', fontWeight: '700', fontSize: '16px' }}>
                      {i === 0 ? '🥇' : i === 1 ? '🥈' : i === 2 ? '🥉' : i + 1}
                    </td>
                    <td>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        {s.slika ? (
                          <img src={s.slika} alt={s.ime} style={{ width: '32px', height: '32px', borderRadius: '50%', objectFit: 'cover', border: '1px solid #e94560' }} />
                        ) : (
                          <div style={{ width: '32px', height: '32px', borderRadius: '50%', background: '#12122a', border: '1px solid #2a2a4a', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px', color: '#e94560' }}>
                            {s.ime.charAt(0)}
                          </div>
                        )}
                        <span style={{ fontWeight: '600', color: '#fff' }}>{s.ime}</span>
                      </div>
                    </td>
                    <td style={{ textAlign: 'center' }}>{s.nastupa}</td>
                    <td style={{ textAlign: 'center', fontWeight: '700', color: '#e94560', fontSize: '17px' }}>{s.prosjekPoSetu}</td>
                    <td style={{ textAlign: 'center', fontWeight: '600', color: '#fff' }}>{s.prosjekUtakmica}</td>
                    <td style={{ textAlign: 'center', color: '#2ed573', fontWeight: '600' }}>{s.prosjekDomaci || '—'}</td>
                    <td style={{ textAlign: 'center', color: '#5378ff', fontWeight: '600' }}>{s.prosjekGost || '—'}</td>
                    <td style={{ textAlign: 'center' }}>{s.maxUkupno}</td>
                    <td style={{ textAlign: 'center', color: '#2ed573' }}>{s.ukupnoSP}</td>
                    <td style={{ textAlign: 'center', color: '#5378ff' }}>{s.ukupnoMP}</td>
                    <td style={{ textAlign: 'center', color: '#666688' }}>{s.prosjekPromasaja}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

export default Ranglista;
